var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuCategory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 30.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.07,31.28a1.3,1.3,0,0,1-.6-.15L27,26.67l-8.48,4.46a1.3,1.3,0,0,1-1.89-1.37l1.62-9.44-6.86-6.69a1.3,1.3,0,0,1,.72-2.22L21.58,10l4.24-8.59A1.3,1.3,0,0,1,27,.72h0a1.29,1.29,0,0,1,1.16.72L32.39,10l9.48,1.38a1.3,1.3,0,0,1,1.05.89,1.28,1.28,0,0,1-.32,1.33l-6.86,6.69,1.62,9.44A1.3,1.3,0,0,1,36.84,31,1.29,1.29,0,0,1,36.07,31.28Zm-21-17.67,5.47,5.32a1.32,1.32,0,0,1,.37,1.15L19.63,27.6l6.75-3.55a1.3,1.3,0,0,1,1.21,0l6.75,3.55-1.28-7.52a1.27,1.27,0,0,1,.37-1.15l5.46-5.32-7.55-1.1a1.31,1.31,0,0,1-1-.71L27,5,23.61,11.8a1.3,1.3,0,0,1-1,.71Z",
    transform: "translate(-10.99 -0.72)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCategory);
export default __webpack_public_path__ + "static/media/menu-category.7a324b4f.svg";
export { ForwardRef as ReactComponent };